import { Alert as AlertBase } from "@mui/material";
import { CheckIcon, WarningIcon } from "@phosphor-icons/react";
import type { CSSProperties, PropsWithChildren } from "react";

type AlertSeverity = "info" | "error" | "warning" | "success";

const severityToStyleMap: Record<AlertSeverity, CSSProperties> = {
  info: {},
  error: { fontWeight: "var(--font-weight-medium)" },
  success: {
    fontWeight: "var(--font-weight-bold)",
    color: "var(--color-core-rahal-400)",
  },
  warning: {},
};

type Props = PropsWithChildren<{
  severity: AlertSeverity;
  "aria-labelledby"?: string;
}>;

export function Alert({
  severity,
  children,
  "aria-labelledby": ariaLabelledBy,
}: Props) {
  return (
    <AlertBase
      severity={severity}
      aria-labelledby={ariaLabelledBy}
      sx={{
        alignItems: "center",
        ...severityToStyleMap[severity],
      }}
      iconMapping={{
        success: (
          <CheckIcon
            className="size-8 animate-pop-in rounded-full bg-surface-accent-soft p-1.5 text-surface-accent-strong"
            weight="bold"
          />
        ),
        error: <WarningIcon className="size-6" weight="bold" />,
      }}
    >
      {children}
    </AlertBase>
  );
}
